import { useNavigate, useLocation } from "react-router-dom";
import { useLiveQuizSocket } from "../../contexts/LiveQuizSocketContext";
import { useTranslation } from "../../hooks/useTranslation";

export default function LiveQuizRejoinBanner() {
    const { socket, activeRoom, setActiveRoom } = useLiveQuizSocket();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    if (!activeRoom) return null;
    if (location.pathname.startsWith("/livequiz/")) return null;

    const handleRejoin = () => {
        if (socket) {
            socket.emit("join_room", { roomCode: activeRoom.roomCode });
        }
        navigate(`/livequiz/game/${activeRoom.roomCode}`);
    };

    const handleClose = () => setActiveRoom(null);

    return (
        <div style={{
            position: "fixed",
            top: 0, left: 0, right: 0,
            zIndex: 9998,
            background: "#1368ce",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}>
            <span style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                {t.liveQuiz.quizRunning} <strong>{activeRoom.quizTitle}</strong>
            </span>
            <div style={{ display: "flex", gap: 10 }}>
                <button
                    onClick={handleRejoin}
                    style={{
                        background: "white", color: "#1368ce", border: "none",
                        borderRadius: 20, padding: "4px 16px",
                        fontWeight: 700, cursor: "pointer", fontSize: "0.9rem",
                    }}
                >
                    {t.liveQuiz.rejoin}
                </button>
            </div>
        </div>
    );
}
